import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { isAuthenticated, hasPermission, loading } = useAuth();

  if (loading) return <div>Loading...</div>;

  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  // ✅ ACCESS DENIED UI
  // 🔥 WAIT until user loads
if (loading) return <div>Loading...</div>;

// 🔥 if no permission required → allow
if (!requiredPermission) return children;

// 🔥 check permission
if (!hasPermission(requiredPermission)) {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-gray-800 mb-2">
          Access Denied
        </h1>
        <p className="text-gray-500">
          You don't have permission to view this page.
        </p>
      </div>
    </div>
  );
}

  // ✅ IMPORTANT (MISSING THA)
  return children;
};

export default ProtectedRoute;